import React from "react";
import MedicalConditionCard from "./MedicalConditionCard";

interface MedicalTabProps {
  patientData: any;
  theme?: "light" | "dark";
}

const MedicalTab: React.FC<MedicalTabProps> = ({ patientData, theme = "light" }) => {
  const medicalConditions = [
    { key: "allergies", label: "Allergies" },
    { key: "gastricProblem", label: "Gastric Problem" },
    { key: "highBP", label: "High BP" },
    { key: "diabetes", label: "Diabetes" },
    { key: "monthlyInjection", label: "Monthly Injection" },
    { key: "pregnancyBreastFeeding", label: "Pregnancy/Breast Feeding" },
    { key: "coughColdFever", label: "Cough/Cold/Fever" },
    { key: "chestpainHeartProblem", label: "Chest Pain/Heart" },
    { key: "epilepsy", label: "Epilepsy" },
    { key: "previousExtraction", label: "Previous Extraction" },
    { key: "previoussurgeries", label: "Previous Surgeries" },
    { key: "covid193Doses", label: "COVID-19 (3 Doses)" },
    { key: "drugHistory", label: "Drug History" },
    { key: "dietaryHistory", label: "Dietary History" },
    { key: "brushingHistory", label: "Brushing History" },
    { key: "medicalHistoryNote", label: "Medical History (Note)" },
    { key: "oralHygieneHistory", label: "Oral Hygiene History" },
    { key: "habitHistory", label: "Habit History" },
    { key: "familyHistory", label: "Family History" },
    { key: "socialHistory", label: "Social History" },
  ];

  const InfoCard: React.FC<{ label: string; value: string }> = ({ label, value }) => (
    <div className={`rounded-lg p-3 ${
      theme === "dark" ? "bg-slate-700/50" : "bg-slate-50"
    }`}>
      <p className={`text-xs uppercase tracking-wide mb-1 ${
        theme === "dark" ? "text-slate-400" : "text-slate-500"
      }`}>{label}</p>
      <p className={`text-sm font-medium ${
        theme === "dark" ? "text-slate-200" : "text-slate-800"
      }`}>{value || "N/A"}</p>
    </div>
  );

  return (
    <div className="space-y-6">
      <div>
        <h4 className={`text-sm font-semibold mb-3 ${
          theme === "dark" ? "text-slate-300" : "text-slate-700"
        }`}>Medical Conditions</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:gap-3">
          {medicalConditions.map((condition) => (
            <MedicalConditionCard
              key={condition.key}
              label={condition.label}
              condition={patientData?.[condition.key] || {}}
              theme={theme}
            />
          ))}
        </div>
      </div>

      <div>
        <h4 className={`text-sm font-semibold mb-3 ${
          theme === "dark" ? "text-slate-300" : "text-slate-700"
        }`}>Examination Notes</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
          <InfoCard 
            label="Extra Oral Examination" 
            value={patientData?.extraOralExamination} 
          />
          <InfoCard 
            label="Intra Oral Examination" 
            value={patientData?.intraOralExamination} 
          />
        </div>
      </div>
    </div>
  );
};

export default MedicalTab;

